import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGetEligibleJobsApiResponse, IGetEligibleJobsParams } from './types';

async function getEligibleJobs(
  params: IGetEligibleJobsParams,
): Promise<IGetEligibleJobsApiResponse> {
  const page = params.page || 1;
  const limit = params.limit || 15;
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetEligibleJobsApiResponse>(
    `/offices/professionals/${params.professionalId}/eligible-jobs`,
    {
      headers: { ...headers, 'x-office': params.xOfficeId ?? undefined },
      params: {
        page,
        limit,
        status: params.status,
        profession: params.profession,
      },
    },
  );

  return response.data;
}

export const eligibleJobsApi = {
  getEligibleJobs,
};
